import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import CloseIcon from "../../../../assets/icons/close-icon";

const TemplateFormatPreview = ({ isModalOpen = false, setIsModalOpen, values }) => {
  console.log(values, "Preview CSV Data");

  // Preview = the sample file as the import will read it: one column per
  // mapped system field, filled from the file column it points to. Built from
  // the live grnColumns mapping (1-based column numbers) - mapped_columns is
  // only filled in on save, so reading it showed an empty preview.
  const fileColumns = values?.excel_columns || [];
  const previewColumns = (values?.grnColumns || [])
    .filter((col) => Number(col?.value) > 0)
    .map((col) => ({
      label: col.label,
      mappedKey: fileColumns[Number(col.value) - 1],
    }))
    .filter((col) => col.mappedKey);

  return (
    <Transition show={isModalOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto"
        onClose={() => setIsModalOpen(false)}
      >
        <div className="flex items-center justify-center min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-100"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-0"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-60" />
          </Transition.Child>

          {/* Modal Container */}
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4"
            enterTo="opacity-100 translate-y-0"
            leave="ease-in duration-0"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-4"
          >
            <div className="mx-auto h-[80vh] w-[80%] p-5 text-left align-middle transition-all transform bg-white shadow-xl rounded-xl">
              <div className="flex justify-between items-start h-[3rem]">
                <span className="text-000000 text-lg fw_600">Preview CSV</span>
                <button
                  type="button"
                  className="close-button bg-transparent border-none p-0 hover:bg-787878"
                  onClick={() => setIsModalOpen(false)}
                >
                  <CloseIcon />
                </button>
              </div>

              {previewColumns.length === 0 ? (
                <div className="flex items-center justify-center h-[calc(100%-3rem)] text-sm text-[var(--description-color)]">
                  Map at least one system field to a file column to preview
                  the import.
                </div>
              ) : (
              /* Table Container */
              <div
                style={{ height: `calc(100% - 3rem)` }}
                className="w-full overflow-auto"
              >
                <table className="w-full">
                  {/* Table Headings */}
                  <thead className="sticky top-0 z-9 bg-F2F4F5">
                    <tr>
                      <th className="tab-header whitespace-nowrap text-xs fw_700 text-475467 bg-F2F4F5 text-start">
                        #
                      </th>
                      {previewColumns.map(({ label }) => (
                        <th
                          key={label}
                          title={label}
                          className="tab-header whitespace-nowrap text-xs fw_700 text-475467 bg-F2F4F5 text-start"
                        >
                          {label}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  {/* Table Body */}
                  <tbody>
                    {values?.excel_rows?.map((row, index) => (
                      <tr key={index}>
                        {/* Row Index */}
                        <td className="tab-cell text-sm fw_400 text-secondary w-20">
                          {index + 1}
                        </td>

                        {/* Dynamically Render Table Cells. Keyed by field -
                            several fields can share one file column. */}
                        {previewColumns.map(({ label, mappedKey }) => (
                          <td
                            key={label}
                            className="tab-cell text-sm fw_400 text-secondary whitespace-nowrap"
                          >
                            {row[mappedKey] || "-"}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              )}
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default TemplateFormatPreview;
